import type { KindResolver } from '@/engine/DynamicPlanning/PlanningEntityFactory';
import { TTVRPlanningEntityKind } from './TTVRPlanningEntityKind';

export function createTTVRPlanningEntityKindResolver(): Array<KindResolver> {
  return [
    {
      kind: TTVRPlanningEntityKind.Papillary,
      regexp: /^Papillary(\s+(\w+))?$/i,
      nameIndex: 2
    },
    {
      kind: TTVRPlanningEntityKind.Commissure,
      regexp: /^((AS)|(AP)|(PS))$/i
    }
  ];
}
